module.exports = __webpack_public_path__ + "img/carteirinha.3b890658.jpeg";